
import Vue from 'vue'
import { getNetwork } from '@/wallet'
import { network } from '@/config'
export default Vue.extend({
  name: 'BaseNetwork',
  mounted() {
    getNetwork().then((_network) => {
      if (typeof _network == 'undefined') return
      this.$network = _network
      this.controlNetwork()
    })
    this.network = network
  },
  data() {
    return {
      systemAlert: false,
      systemAlertMessage: '',
      network: '',
    }
  },
  methods: {
    controlNetwork() {
      if (typeof this.$network == 'undefined') return
      if (this.network !== this.$network) {
        this.systemAlert = true
        this.systemAlertMessage = 'Switch EverWallet to the ' + this.network + ' network. Your wallet using ' + this.$network + ' now.'
      } else {
        this.systemAlert = false
      }
    },
  },
  watch: {
    $network() {
      this.controlNetwork()
    },
  },
})
